import { createSlice } from '@reduxjs/toolkit';

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        expandedTab: ["starred", "threads", "spaces", "dms"],
        activeTab: null,
        dashboardActiveTab: "Home",
    },
    reducers: {
        setExpandedTab: (state, action) => {
            if(state.expandedTab.includes(action.payload)) {
                state.expandedTab = state.expandedTab.filter(tab => tab !== action.payload);
            } else {
                state.expandedTab.push(action.payload);
            }
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        dashboardActiveTab: (state, action) => {
            state.dashboardActiveTab = action.payload;
        }
    },
});

export const { setExpandedTab, setActiveTab, dashboardActiveTab } = sidebarSlice.actions;

export const sidebarReducer = sidebarSlice.reducer;